import React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import {
  useProductPlatformFeatures,
  useProductPlatformFeaturesEditable,
  useProductSpecificPlatformFeatures,
} from 'api/productPlatformFeatures.hooks'
import { ProductPlatformFeatureItem } from './ProductPlatformFeatureItem'

interface ProductPlatformFeaturesProps {
  productId: number
}

export function ProductPlatformFeatures({
  productId,
}: ProductPlatformFeaturesProps) {
  const platformFeatureList = useProductSpecificPlatformFeatures()
  const platformFeatureStatus = useProductPlatformFeatures(productId)
  const isEditable = useProductPlatformFeaturesEditable(productId)

  return (
    <Paper elevation={1} sx={{ p: 3 }}>
      <Typography sx={{ fontWeight: 'bold', mb: 1 }}>
        Product Platform Features
      </Typography>
      <Typography variant="caption">
        You are {isEditable ? 'able' : 'not able'} to edit the platform features
        for this product.
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {platformFeatureList.map((feature) => {
          const productPlatformFeature = platformFeatureStatus.find(
            (p) => Number(p.platform_feature_id) === feature.id,
          )

          return (
            <ProductPlatformFeatureItem
              key={feature.id}
              isEditable={isEditable}
              productId={productId}
              feature={feature}
              isChecked={productPlatformFeature?.is_enabled ?? false}
            />
          )
        })}
      </Box>
    </Paper>
  )
}
